import { createAction, props, union } from '@ngrx/store';
import { MafBundleQueryI } from 'src/app/api/maf-bundle/maf-bundle-query.int';
import { MafBundleResponseI } from 'src/app/api/maf-bundle/maf-bundle-result.int';
/* eslint-disable max-len */

export const error = createAction('[MAF Bundle] Error', props<{
  messageText: string;
}>());
export const reset = createAction('[MAF Bundle] Reset');
export const load = createAction('[MAF Bundle] Save', props<{
  query: MafBundleQueryI;
}>());
export const received = createAction('[MAF Bundle] Received', props<{
  data: MafBundleResponseI;
}>());

const all = union({
  error,
  load,
  received,
  reset,
});
export type Actions = typeof all;
